import { render, staticRenderFns } from "./ProposalViewEmail.vue?vue&type=template&id=6f397e76&scoped=true&lang=pug"
import script from "./ProposalViewEmail.vue?vue&type=script&lang=js"
export * from "./ProposalViewEmail.vue?vue&type=script&lang=js"
import style0 from "./ProposalViewEmail.vue?vue&type=style&index=0&id=6f397e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f397e76",
  null
  
)

export default component.exports